import { Location } from '../types';
import { ChangeEvent, useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { usePrompt } from '@/utils/prompt';
import progressAnimation from '@/assets/animation/save_loader.json';
import { showNotification } from '@/utils/notificationUtils';
import { LocationInputField } from '@/components/Form/LocationInputField';
import {
  useUpdatePrefillLocation,
} from '@/features/location/api/locationRequests';
import { useNavigate } from 'react-router-dom';

export const PrefillLocationInfo = () => {
  const navigate = useNavigate();
  const [isBlocking, setIsBlocking] = useState(false);
  const [businessData, setBusinessData] = useState<Location>();
  const updateLocation = useUpdatePrefillLocation();
  const [googleData, setGoogleData] = useState();
  usePrompt('If you leave before saving, your changes will be lost', isBlocking);

  useEffect(() => {
    if (googleData) {
      const bizDt: Location = businessData || ({} as Location);

      const val = googleData as any;
      bizDt.name = val.name;
      bizDt.address = val.address;
      bizDt.googlePlaceId = val.place_id;

      setIsBlocking(true);
      setBusinessData({ ...bizDt });
    }
  }, [googleData]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (businessData) {
      const bizDt: Location = businessData || ({} as Location);

      if (event.target.id === 'address') {
        bizDt.address = event.target.value;
      }

      setBusinessData({ ...bizDt });
      setIsBlocking(true);
    }
  };

  const validate = () => {
    if (!businessData || !businessData.name || businessData.name.trim().length < 1) {
      showNotification({
        type: 'info',
        title: 'Please select business name',
      });
      return false;
    }
    return true;
  };
  return (
    <div>
      <div className="page-title">
        Location Details
      </div>
      <div className="card-add-service">
        <form>
          <div className="mb-20-p">
            <LocationInputField
              id="name"
              value={ businessData?.name }
              onChange={ (ev) => {
                const val = ev.target.value as any;
                setGoogleData(val);
              } }
              onTextChange={ (ev: ChangeEvent<HTMLInputElement>) => {
                setIsBlocking(true);
              } }
              className="cust-input"
              placeholder="Business Name"
            />
          </div>
          <div className="mb-20-p">
            <input
              id="address"
              value={ businessData?.address }
              onChange={ handleChange }
              type="text"
              className=" cust-input"
              placeholder="Address"
            />
          </div>
          <div className="mb-20-p save-btn-outer">
            <button
              onClick={ async () => {
                if (validate() && !updateLocation.isLoading) {
                  setIsBlocking(false);
                  await updateLocation.mutateAsync({ data: businessData });
                  navigate('/locations');
                }
              } }
              type="button"
              className="btn-style loading-btn-style"
            >
              <div className="loader-animation-btn">
                { updateLocation.isLoading ? (
                  <>
                    <Lottie className="progress-animation" animationData={ progressAnimation } />
                    <span>Saving...</span>
                  </>
                ) : (
                  <span>Save</span>
                ) }
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
